//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import Services from "~/components/services/Services.vue";

export default BaseCmsBlock.extend({
  name: "BossBlock",

  created: async function () {
    const {data: services} = await this.$api.agent.transport.get(`operations?filter[category_id]=${this.values.category_id}&per-page=1000`).catch((err) => {
      return {data: []}
    });
    this.services = services;
  },

  data: function () {
    return {
      services: [],
    }
  },

  computed: {
    title: function () {
      return this?.values?.title || ""
    }
  },

  components: {
    Services
  }
});
